import React from "react";
import { Icons } from "./icons";
import { cn } from "@/lib/utils";
import { Link } from "./link";

export type IconTextProps = {
  className?: string;
};

export default function IconText({ className }: IconTextProps) {
  return (
    <Link
      href="/"
      className={cn(
        "font-bold text-primary [&_svg]:!h-full [&_svg]:md:!h-[70px] [&_svg]:!w-auto !h-full !p-0",
        className
      )}
      title="Oasi Homepage"
    >
      <span className="sr-only">Homepage</span>
      <Icons.oasiText />
    </Link>
  );
}
